export const parseIntegrationData = (integrationData) => {
  if (!integrationData) return {};
  if (typeof integrationData === 'object') return integrationData;
  if (typeof integrationData !== 'string') return {};
  try {
    return JSON.parse(integrationData);
  } catch (err) {
    console.warn('Failed to parse integration_data JSON', err);
    return {};
  }
};

export const mergeIntegrationData = (integrationData, patch = {}) => {
  const base = parseIntegrationData(integrationData);
  return {
    ...base,
    ...patch,
  };
};

export const getTvControlsIntegration = (device) => {
  const integration = parseIntegrationData(device?.integration_data);
  return integration.tv_controls || null;
};

export const hasAssistantTvControl = (device) => {
  const tvControls = getTvControlsIntegration(device);
  const connected = tvControls?.connected_methods;
  return Array.isArray(connected) && connected.includes('assistant');
};

